export function Header({
  title,
  subtitle,
  actions,
  shopPicker,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  shopPicker?: React.ReactNode;
}) {
  return (
    <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-gray-200 bg-white/80 px-8 backdrop-blur">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-4">
        {shopPicker}
        {actions}
      </div>
    </header>
  );
}

export function ShopPicker({
  shops,
  currentShopId,
  onChange,
}: {
  shops?: { id: string; name: string }[];
  currentShopId: string | null;
  onChange: (shopId: string) => void;
}) {
  if (!shops || shops.length < 2) return null;
  return (
    <div className="flex items-center gap-2 text-sm text-gray-600">
      <span className="hidden sm:inline">当前门店</span>
      <select
        value={currentShopId ?? ''}
        onChange={(e) => onChange(e.target.value)}
        className="h-9 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {shops.map((shop) => (
          <option key={shop.id} value={shop.id}>
            {shop.name}
          </option>
        ))}
      </select>
    </div>
  );
}
